"use strict";

EWS.Ready(() => {
    if (UserType !== "Guest") {
        requestIdleCallback(() => {
            InitEncompassHelp();
        });
    }
});

let bevMenu;

function InitEncompassHelp() {
    const pageHeader = document.querySelector("#Header .Inner");

    if (pageHeader && !IsImpersonateUser) {
        const notDSDLink = window.location.hostname !== "dsdlink.com" && window.location.hostname !== "dsdlink.encompass8.com" && Distributor !== "DSDLink";
        const ecpHelpButton = document.createElement("ecp-btn");
        ecpHelpButton.setAttribute("type", "ghost");
        ecpHelpButton.setAttribute("size", "large");
        ecpHelpButton.setAttribute("icon", "ews-icon-aihelp");
        ecpHelpButton.id = "encompasshelpicon";

        pageHeader.insertBefore(ecpHelpButton, pageHeader.children[pageHeader.children.length - 2]);

        ecpHelpButton.addEventListener("click", (event) => {
            let helpMenu = document.getElementById("ecp-help-menu");

            if (!helpMenu) {
                helpMenu = WriteEncompassHelpMenu(notDSDLink);
                WriteCurrentHelpResources();
            }

            helpMenu.ShowMenu(event.currentTarget);
        });

        const whatsNewPopUp = notDSDLink && UserType !== "Support" && !EC_Fmt.isMobile && EC_Fmt.GetCookie("DisplayWhatsNewPopup") === "true";
        if (whatsNewPopUp && EC_Fmt.GetPageParameter("DashboardID") !== "162470") {
            setTimeout(() => {
                const whatsNewAttention = document.createElement("div");
                whatsNewAttention.classList.add("attentionDialog");
                whatsNewAttention.id = "whatsNewAttentionDialog";

                whatsNewAttention.innerHTML = "<div><span class=ews-icon-alert></span></div>"
                    + `<div><div>Encompass ${EC_Fmt.Trn("has been updated")}</div>`
                    + `<div>${EC_Fmt.Trn("Read about changes and how to take advantage of new features in the")} ${EC_Fmt.Left(ECPVersion, 5)} ${EC_Fmt.Trn("release")}</div>`
                    + `<div><ecp-btn type=permanent icon=ews-icon-arrowright>${EC_Fmt.Trn("View release notes")}</ecp-btn><ecp-btn type=primary style=color:var(--text-secondary-onbg-action)>${EC_Fmt.Trn("Dismiss")}</ecp-btn></div>`
                    + "</div>";

                document.body.appendChild(whatsNewAttention);

                const releaseNotesButton = whatsNewAttention.querySelector("ecp-btn[type=permanent]");
                const dismissButton = whatsNewAttention.querySelector("ecp-btn[type=primary]");

                const clickWhatsNewButton = (event) => {
                    whatsNewAttention.style.display = "none";

                    const myRequest = new ECP.EC_Request("SetUserSetting");
                    myRequest.SetReturnType(ECP.EC_ReturnType.Text);
                    myRequest.AddRequestVariable("SettingName", "hasSeenWhatsNewPopup");
                    myRequest.AddRequestVariable("SettingValue", "true");
                    myRequest.Submit();
                    EC_Fmt.DeleteCookie("DisplayWhatsNewPopup");

                    if (event.currentTarget === releaseNotesButton) {
                        window.open("Home?DashboardID=162470");
                    }
                };

                releaseNotesButton.addEventListener("click", clickWhatsNewButton);
                dismissButton.addEventListener("click", clickWhatsNewButton);

                dismissButton.shadowRoot.querySelector("Button").style = "background:var(--neutral-90);color:var(--text-onbg-action);border:0";

                const EnableBetaDialog = document.getElementById("EnableBeta");
                if (EnableBetaDialog) {
                    const whatsNewRectangle = whatsNewAttention.getBoundingClientRect();
                    EnableBetaDialog.style.top = `${whatsNewRectangle.top + whatsNewRectangle.height + 20}px`;
                }
            }, 1000);
        }
    }
}

function WriteEncompassHelpMenu(notDSDLink) {
    let html = "<ecp-list style=padding:24px>";

    if (notDSDLink) {
        html += `<ecp-list-item href="Home?DashboardID=162470"id=help-menu-whats-new>`
            + "<div><span style=\"font-size:20px;width:28px;margin:12px 8px 0 0\"class=ews-icon-news></span></div>"
            + "<ecp-list-item-content>"
            + `<ecp-list-item-title style=font-weight:700>${EC_Fmt.Trn("What’s new")}</ecp-list-item-title>`
            + `<ecp-list-item-subtitle>${EC_Fmt.Trn("Latest Release Notes")}</ecp-list-item-subtitle>`
            + "</ecp-list-item-content>"
            + "</ecp-list-item>"

            + "<ecp-list-item id=ask-bev-list-item>"
            + "<img src=\"https://cdn.e8.co/GlobalDocs/1916924-THUMB.PNG\"loading=lazy height=40px width=40px />"
            + "<ecp-list-item-content>"
            + `<ecp-list-item-title style=font-weight:700>${EC_Fmt.Trn("Ask")} Bev</ecp-list-item-title>`
            + `<ecp-list-item-subtitle>${EC_Fmt.Trn("AI Assistant")}</ecp-list-item-subtitle>`
            + "</ecp-list-item-content>"
            + "</ecp-list-item>";
    }

    html += "<ecp-list-item style=background-color:var(--layer-1)>"
        + "<ecp-list-item-content>"
        + `<ecp-list-item-title style=font-weight:700>Help resources</ecp-list-item-title>`
        + `<ecp-list-item-subtitle id=help-resources-sub-title>${EC_Fmt.Trn("Based on your current page")}</ecp-list-item-subtitle>`
        + "</ecp-list-item-content>"
        + "</ecp-list-item>"

        + "<ecp-list-item>"
        + "<ecp-input id=ecp-help-dialog-input type=text icon=ews-icon-search placeholder=\"Search help resources\"style=width:100%></ecp-input>"
        + "</ecp-list-item>"
        + "<div class=ecp-help-empty></div>"
        + "<div class=ecp-help-content style=min-height:100px></div>";

    // Task 1175731: Remove the 'Ask a Question' link from the help resources dialog in DSDLink only
    if (notDSDLink) {
        // EC-34607: With Bev on Fin, support options open the Messenger's Tickets space; Intercom's Customer Portal can't sign in users from customer domains
        html += `<ecp-list-item id=help-menu-support-pourtal${BevUsesFin ? "" : " href=Home?DashboardID=160363"}>`
            + "<div><span style=\"font-size:24px;width:28px;margin:10px 4px 0 0\"class=ews-icon-support></span></div>"
            + "<ecp-list-item-content>"
            + `<ecp-list-item-title style=font-weight:700>${EC_Fmt.Trn("More support options")}</ecp-list-item-title>`
            + `<ecp-list-item-subtitle id=help-resources-sub-title>Encompass Support Pourtal</ecp-list-item-subtitle>`
            + "</ecp-list-item-content>"
            + "</ecp-list-item>";
    }

    html += "</ecp-list>";

    const helpMenu = document.createElement("ecp-menu");
    helpMenu.id = "ecp-help-menu";
    helpMenu.innerHTML = html;
    document.body.appendChild(helpMenu);

    EC_Fmt.AfterInput(helpMenu.querySelector("#ecp-help-dialog-input"), 0, 350, async (_, search) => {
        if (search.length >= 3) {
            const myRequest = new ECP.EC_Request("EncompassHelp_HelpResourcesSearch");
            myRequest.AddRequestVariable("SearchStr", search);

            const result = await myRequest.Submit();
            WriteEncompassHelpContent(result, search);
        } else if (search.length === 0) {
            WriteCurrentHelpResources();
        }
    });

    const askBevItem = helpMenu.querySelector("#ask-bev-list-item");
    if (askBevItem) {
        askBevItem.addEventListener("click", () => {
            ShowBevMenu("show");
        });
    }

    const supportItem = helpMenu.querySelector("#help-menu-support-pourtal");
    if (supportItem && BevUsesFin) {
        supportItem.addEventListener("click", () => {
            ShowBevMenu("showSpace", "tickets");
        });
    }

    return helpMenu;
}

// EC-34607: finArgs is the Intercom command the Fin Messenger runs inside the panel, such as ("show") or ("showSpace", "tickets")
function ShowBevMenu(...finArgs) {
    if (!bevMenu) {
        let bevContent = "";
        if (!BevUsesFin) {
            const pageDescription = document.querySelector("head > meta[name='Description'][content]");
            let context = `You are a chatbot for the Encompass system that is embedded on the Encompass website. `
                + `The user is viewing the ${encodeURIComponent(document.querySelector("head > title").innerText)} dashboard page on the Encompass website.`;
            if (Settings?.DashboardID === ECP.CommonDashboards.TableView) {
                context += ` The following is a description of the page: This is a table view of the ${EC_Fmt.GetPageParameter("TableName")} table. Showing all of the rows in this table, with a default set of columns. Users can modify the columns (which are displayed, sequence) and add filters, as well as add sub-tables to the view, visit audits on each record, or navigate to other associated records through the database.`;
            } else if (Settings?.DashboardID === ECP.CommonDashboards.TableEdit) {
                context += ` The following is a description of the page: This is edit for a single record on the ${EC_Fmt.GetPageParameter("TableName")} table. Allows user to modify values on this record if they have the required edit permission for each field.`;
            } else if (Settings?.DashboardID === ECP.CommonDashboards.TableMerge) {
                context += ` The following is a description of the page: This is delete and merge for a single record on the ${EC_Fmt.GetPageParameter("TableName")} table. This is displayed as a confirmation before deleting a record, and to allow the user to decide what action to take with other records associated with the record being deleted.`;
            } else if (Settings?.DashboardID === ECP.CommonDashboards.TableCopy) {
                context += ` The following is a description of the page: This is a copy page for one or many records on the ${EC_Fmt.GetPageParameter("TableName")} table. This allows the user to create a copy of the record(s) and decide if any of the sub-table records associated with them should be copied as well. Users can also tweak the ending values on the newly created records before they are created.`;
            } else if (pageDescription) {
                context += ` The following is a description of the page: ${encodeURIComponent(pageDescription.getAttribute("content"))}`;
            }

            bevContent = `<iframe src="https://app.wonderchat.io/chatbot/cllr3j5rs02ltnc21226iron4?userId=${AuthenticationID}&context=${context}"style=border-width:0 allow="autoplay;display-capture;clipboard-read;microphone"width=100% height=100%></iframe>`;
        }

        bevMenu = EC_Fmt.HtmlStrToElement("<ecp-menu id=ecp-bev-display-menu>"
            + "<ecp-list style=padding:24px>"

            + "<ecp-list-item id=ask-bev-go-back>"
            + "<div><span style=\"font-size:20px;width:26px;margin:10px 4px 0 0\"class=ews-icon-back></span></div>"
            + "<ecp-list-item-content>"
            + `<ecp-list-item-title style=font-weight:700;padding-top:7px>Back to all support options</ecp-list-item-title>`
            + "</ecp-list-item-content>"
            + "</ecp-list-item>"

            + `<ecp-list-item id=ecp-bev-iframe-item>${bevContent}</ecp-list-item>`

            + "</ecp-list></ecp-menu>");

        document.body.appendChild(bevMenu);

        bevMenu.querySelector("#ask-bev-go-back").addEventListener("click", () => {
            bevMenu.ShowMenu();
        });

        if (BevUsesFin) {
            // The Messenger lives outside the panel, so it follows the panel closed
            new MutationObserver(() => {
                if (!bevMenu.classList.contains("expanded")) {
                    window.Intercom?.("hide");
                    document.getElementById("ecp-bev-fin-position")?.remove();
                }
            }).observe(bevMenu, { attributes: true, attributeFilter: ["class"] });
        }
    }

    if (!bevMenu.classList.contains("expanded")) {
        bevMenu.ShowMenu(document.getElementById("encompasshelpicon"));
    }

    setTimeout(() => {
        const isSmallScreen = window.innerWidth <= 600;
        bevMenu.style.maxHeight = `calc(99vh - ${isSmallScreen ? 0 : bevMenu.getBoundingClientRect().top}px)`;

        const iFrame = bevMenu.querySelector("#ecp-bev-iframe-item");
        iFrame.style.maxHeight = `calc(99vh - ${isSmallScreen ? 0 : iFrame.getBoundingClientRect().top + 24}px)`; // 24 = padding at the bottom of the frame

        if (BevUsesFin) {
            ShowFinInPanel(iFrame, finArgs);
        }
    }, 160);
}

let finLoadingCover = null;
let finCallbacksAdded = false;

// EC-34607: Intercom only has a floating Messenger, so it is pinned over the panel's chat area
async function ShowFinInPanel(finItem, finArgs) {
    finItem.textContent = "";
    const loadingCover = ECP.Dialog.ShowLoading("", finItem);
    finLoadingCover = loadingCover;

    const fin = await EC_Fmt.BootIntercom(true);
    if (fin.errors) {
        ECP.Dialog.HideLoading(loadingCover);
        // EC-35321: the Messenger can't open, so its chat area tells the user what to unblock
        if (fin.errors[0].title === "Bev Blocked") {
            finItem.innerHTML = `<div style=padding:16px>${fin.errors[0].detail}</div>`;
            return;
        }
        bevMenu.CloseMenu();
        ECP.Dialog.Alert(fin.errors[0].detail);
        return;
    }

    const rect = finItem.getBoundingClientRect();
    let positionStyle = document.getElementById("ecp-bev-fin-position");
    if (!positionStyle) {
        positionStyle = document.createElement("style");
        positionStyle.id = "ecp-bev-fin-position";
        document.head.appendChild(positionStyle);
    }
    positionStyle.textContent = `#intercom-container .intercom-messenger-frame{top:${rect.top}px!important;left:${rect.left}px!important;width:${rect.width}px!important;height:${rect.height}px!important;max-height:none!important;bottom:auto!important;right:auto!important}`;

    if (!finCallbacksAdded) {
        finCallbacksAdded = true;
        window.Intercom("onShow", () => {
            ECP.Dialog.HideLoading(finLoadingCover);
            finLoadingCover = null;
        });
        // Intercom's own close button closes the panel with it
        window.Intercom("onHide", () => {
            bevMenu.CloseMenu();
        });
    }
    window.Intercom(...finArgs);

    // Intercom gives no error when it refuses a user (it answers 403), the Messenger just never opens
    setTimeout(() => {
        if (finLoadingCover === loadingCover && bevMenu.classList.contains("expanded")) {
            ECP.Dialog.HideLoading(loadingCover);
            bevMenu.CloseMenu();
            ECP.Dialog.Alert("Bev could not be started. Please try again, or email support@encompass8.com if this keeps happening.");
        }
    }, 15000);
}

async function WriteCurrentHelpResources() {
    const helpContent = document.querySelector("#ecp-help-menu .ecp-help-content");
    const timer = setTimeout(() => {
        ECP.Dialog.ShowLoading("", helpContent);
    }, 1000);

    if (Settings) {
        const myRequest = new ECP.EC_Request("EncompassHelp_GetCurrentHelpResources");
        myRequest.AddRequestVariable("DashboardID", Settings.DashboardID);

        if (Settings.DashboardID === ECP.CommonDashboards.TableView) {
            myRequest.AddRequestVariable("TableName", EC_Fmt.GetPageParameter("TableName"));
        }

        const result = await myRequest.Submit();

        clearTimeout(timer);
        helpContent.style.minHeight = "auto";

        WriteEncompassHelpContent(result);
    }
}

function WriteEncompassHelpContent(result, search) {
    const helpContent = document.querySelector("#ecp-help-menu .ecp-help-content");
    const helpEmpty = document.querySelector("#ecp-help-menu .ecp-help-empty");
    helpContent.innerHTML = "";
    helpEmpty.innerHTML = "";

    const AvailableResourceLength = result.AvailableResourceLength;
    const ResourceResult = result.ResourceResult;
    let html = "";
    let ApplicationID = 0;

    if (ResourceResult?.length > 0) {
        for (let i = 0; i < ResourceResult.length; i++) {
            const ApplicationObj = ResourceResult[i];
            ApplicationID = ApplicationObj.ApplicationID;

            for (let j = 0; j < ApplicationObj.HelpResources.length; j++) {
                const HelpResourcesObj = ApplicationObj.HelpResources[j];
                const Url = `Home?DashboardID=184447&HelpResourcesID=${HelpResourcesObj.HelpResourcesID}&`;

                html += `<ecp-list-item href="${Url}">`
                    + "<ecp-list-item-content>"
                    + `<ecp-list-item-title title="${HelpResourcesObj.Notes}">${HelpResourcesObj.Title}</ecp-list-item-title>`;

                if (!EC_Fmt.isNull(search)) {
                    html += `<ecp-list-item-subtitle>${ApplicationObj.Application}</ecp-list-item-title>`;
                }

                html += "</ecp-list-item-content>"
                    + `<ecp-list-item-action><span class=ews-icon-externallink></span></ecp-list-item-action>`
                    + "</ecp-list-item>";
            }
        }
    } else {
        let title;
        let message;

        if (EC_Fmt.isNull(search)) {
            title = "Search help resources";
            message = "Use the box above to find a help resource and get started.";
        } else {
            title = "No resources found";
            message = "There aren’t any resources that match your search. Try adjusting your search, or browse all help resources using the link below.";
        }

        let emptyHtml = `<ecp-empty illustration=${EC_Fmt.isNull(search) ? "search" : "empty"}>`
            + `<ecp-empty-title>${title}</ecp-empty-title>`
            + `<ecp-empty-body>${message}</ecp-empty-body>`;

        if (!EC_Fmt.isNull(search)) {
            emptyHtml += "<div>"
                + "<ecp-btn class=ecp-help-clear>Clear search</ecp-btn>"
                + "<ecp-btn type=primary href=Home?DashboardID=184447>Browse all help resources</ecp-btn>"
                + "</div>";
        }

        emptyHtml += "</ecp-empty>";

        helpEmpty.innerHTML = emptyHtml;
    }

    if (AvailableResourceLength > 0 && (EC_Fmt.isNull(search) || (ResourceResult?.length > 0))) {
        let title;
        let Url;

        if (ResourceResult?.length > 0) {
            title = `+${AvailableResourceLength} more relevant resources`;

            let queryString = "";

            if (!EC_Fmt.isNull(search)) {
                queryString = `SearchStr=${encodeURIComponent(search)}`;
            } else if (ApplicationID > 0) {
                queryString = `ApplicationID=${ApplicationID}`;
            }

            Url = `Home?DashboardID=184447&${queryString}`;
        } else {
            title = `${AvailableResourceLength} total resources available`;
            Url = "Home?DashboardID=184447&";
        }

        html += `<ecp-list-item style=font-weight:700 href="${Url}">`
            + `<ecp-list-item-title>${title}</ecp-list-item-title>`
            + `<ecp-list-item-action><span style=padding-right:8px>View all</span><i class=ews-icon-externallink></ecp-list-item-action>`
            + "</ecp-list-item>";
    }

    helpContent.innerHTML = html;

    const helpClear = helpEmpty.querySelector(".ecp-help-clear");
    if (helpClear) {
        helpClear.addEventListener("click", () => {
            const helpDialogInput = document.getElementById("ecp-help-dialog-input");
            helpDialogInput.value = "";
            helpDialogInput.querySelector("input").value = "";
            WriteCurrentHelpResources();
        });
    }

    ECP.Dialog.HideLoading();
}
